class FontLoadError extends Error {
  constructor(fontFamily, fontUrl, error = '') {
    super(error)
    this.name = 'FontLoadError'
    this.message = `Error while loading font. fontFamily "${fontFamily}", fontUrl "${fontUrl}". ${error}`
  }
}
export default FontLoadError
